import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectors as transactionsSelectors,
} from "reducers/transactions";
import {
  selectors as afipPaymentLinkSelectors, actions as afipPaymentLinkActions,
} from "reducers/afipPaymentLink";
import { connect } from "react-redux";
import Notification from "pages/_components/Notification";
import Button from "pages/_components/Button";
import TransactionFilters from "pages/afipPaymentLink/servicesPayment/components/TransactionFilters";
import ProductFilters from "pages/_components/ProductFilters";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import Drawer from "pages/_components/Drawer/Drawer";
import TransactionList from "pages/_components/product/List";
import GridTable from "pages/_components/GridTable/GridTable";
import PaymentItem from "pages/afipPaymentLink/servicesPayment/components/ItemRow";
import TitleColumns from "pages/afipPaymentLink/servicesPayment/components/TitleColumns";
import CustomData from "pages/_components/CustomData/CustomData";
import * as i18n from "util/i18n";
import { push } from "connected-react-router";

const TransactionsHistory = ({ paymentsList, isDesktop }) => {
    const dispatch = useDispatch();

    const fetching = useSelector(transactionsSelectors.getFetching);
    const [filtersAreVisible, setFiltersAreVisible] = useState(false);

    const handleClickShowFilters = () => setFiltersAreVisible(true);
    const handleClickHideFilters = () => setFiltersAreVisible(false);

    useEffect(() => {
       dispatch(afipPaymentLinkActions.setPaymentsFilterOpen(filtersAreVisible));
    }, [filtersAreVisible]);
    

    const paymentsPerBatch = isDesktop ? 10 : 5;
    const [paymentsToDisplay, setPaymentsToDisplay] = useState([]);
    const [fetchingMoreData, setFetchingMoreData] = useState(false);
    const hasMoreData = paymentsList?.length > paymentsToDisplay?.length;
    const row = isDesktop ? 1 : 4;    

    useEffect(() => {
        if (paymentsList?.length > 0) {
            setPaymentsToDisplay(paymentsList?.slice(0, paymentsPerBatch));
        }
    }, [paymentsList]);


    useEffect(() => {
        if (fetching && (paymentsList && paymentsList.length === 0 || hasMoreData)) {
            setFetchingMoreData(true);
        } else {
            setFetchingMoreData(false);
        }
    }, [fetching]);


    const fetchMoreTransactions = () => {
        const currentLength = paymentsToDisplay?.length;
        const nextLength = currentLength + paymentsPerBatch;
        const newItems = paymentsList?.slice(0, nextLength);
        setPaymentsToDisplay(newItems);
    };

    const viewTicket = (transactionId) => {
       dispatch(push(`newServicePayment/transaction/${transactionId}`));
    };

  return (
    <Fragment>
      <Notification scopeToShow="transactions" />
   
         <ViewTitle id="payments.history.title" />
             <div>
                <CustomButton
                className="btn-link show-filters-button-trasactions"
                func={handleClickShowFilters}
                icon="images/figma/icon/filter.svg"
                text="global.filter"
                textType="I18N"
                />
            </div>

            <Drawer openSidebar={filtersAreVisible} toggleSidebar={handleClickHideFilters}>
            <div className="container full-width">
                <h2 className="title-content text-center">
                   {i18n.get("payments.filter.title")}
                </h2>
                <div className="row">
                <ProductFilters
                    closeMoreFiltersWhenSiblingClick
                    moreFilters={
                    <TransactionFilters
                        dispatch={dispatch}
                        isDesktop
                        fetching={fetching}
                        searchByStatus
                        handleClickHideFilters={handleClickHideFilters}
                    />
                    }
                    moreFiltersClosedKeyLabel="accounts.movements.filters.more"
                    moreFiltersOpenedKeyLabel="accounts.movements.filters.less"
                    isDesktop
                >
                </ProductFilters>
                </div>
            </div>
            </Drawer>


            <div className="container">
                    {paymentsToDisplay && paymentsToDisplay?.length > 0 ? (
                        <TransactionList
                            fetchingWithPreviousData
                            fetching={fetching && fetchingMoreData}
                            items={paymentsToDisplay}
                            noFiltersDataText="global.no.results"
                            renderItem={(item) => (
                                <GridTable.Container
                                    key={`payments-item-${item.idTransaction}`}
                                    columns={!isDesktop && 6}
                                    columnsTemplate={isDesktop && "repeat(5, 1fr) 40px"}
                                    className={!isDesktop && "box box-shadow"}>
                                    <PaymentItem
                                        key={`transaction-${item.idTransaction}`}
                                        payment={item}
                                        isDesktop={isDesktop}
                                        viewTicket={()=>viewTicket(item.idTransaction)}
                                    />
                                </GridTable.Container>
                            )}>
                            {(listItem) => (
                                <GridTable>
                                    {isDesktop && (
                                        <GridTable.Header>
                                            <GridTable.Container rows={row} columnsTemplate="repeat(5, 1fr) 40px">
                                                <TitleColumns />{" "}
                                            </GridTable.Container>
                                        </GridTable.Header>
                                    )}
                                    <GridTable.Body>{listItem}</GridTable.Body>
                                    {hasMoreData && (
                                        <Button
                                            bsStyle="link"
                                            onClick={() => fetchMoreTransactions()}
                                            image="images/figma/icon/arrow.svg"
                                            label="global.showMore"
                                            className="view-more"
                                        />
                                    )}
                                </GridTable>
                            )}
                        </TransactionList>
                    ) : (
                        <div className="container--alert" role="alert">
                            <div className="alert alert-info">
                                <CustomData
                                    icon="information_fill.svg"
                                    titleText={i18n.get("payments.history.noresults")}
                                    keepSpaceIfNoValue={false}
                                />
                            </div>
                        </div>
                    )}
                </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
    paymentsList: afipPaymentLinkSelectors.getPaymentsList(state),
    fetching: afipPaymentLinkSelectors.getFetching(state),
});

export default connect(mapStateToProps)(TransactionsHistory);
